import { Badge, Collapse, Flex, Space, Typography } from 'antd'
import { useBudgetListOwn } from 'src/pages/budget/budgetRequests/hooks'
import { OwnApproveTable } from './component'
import styles from './styles.module.css'
import { TStatusPeriod } from 'src/pages/budget/types'

type Props = {
  budgetPeriodName: string | null
  currentPeriodStatus?: TStatusPeriod
}
export const RequestListOwnApprove = ({
  budgetPeriodName,
  currentPeriodStatus,
}: Props) => {
  const { budgetListOwnApprove, filteredBudgetListOwnApprove } =
    useBudgetListOwn()
  const { Text } = Typography
  if (
    !budgetListOwnApprove ||
    !filteredBudgetListOwnApprove ||
    budgetListOwnApprove.length === 0
  )
    return null
  return (
    <Collapse
      items={[
        {
          key: '1',
          label: (
            <Space>
              <Text strong style={{ fontSize: 28 }}>
                Мои принятые заявки / {budgetPeriodName ?? ''}
              </Text>
              <Badge
                count={filteredBudgetListOwnApprove.length}
                showZero
                color="white"
                style={{ color: 'black', borderRadius: '4px' }}
              />
            </Space>
          ),
          children: (
            <Flex align="center" justify="center" style={{ minHeight: '15em' }}>
              <OwnApproveTable
                list={budgetListOwnApprove}
                filterList={filteredBudgetListOwnApprove}
              />
            </Flex>
          ),
        },
      ]}
      className={styles.collapse}
      defaultActiveKey="1"
      expandIconPosition="end"
      style={{ backgroundColor: 'var(--color-green-20)' }}
    />
  )
}
